module.exports = __webpack_public_path__ + "img/default_skillgo.766e29b6.jpg";